import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2VideoIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 47 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47),
    children: [/*#__PURE__*/jsx("path", {
      d: "M2.75 1.25h41.5a1.5 1.5 0 011.5 1.5v41.5a1.5 1.5 0 01-1.5 1.5H2.75a1.5 1.5 0 01-1.5-1.5V2.75a1.5 1.5 0 011.5-1.5z"
    }), /*#__PURE__*/jsx("path", {
      d: "M19.228 30.624a1.252 1.252 0 01-1.152 0 1.042 1.042 0 01-.576-.912V16.466a1.042 1.042 0 01.576-.912 1.252 1.252 0 011.152 0l12.69 6.622a1.01 1.01 0 010 1.83z"
    })]
  });
};

export { PM2VideoIcon };
//# sourceMappingURL=video.js.map
